<template>
  <div class="export-buttons no-print">
    <button
      type="button"
      class="export-buttons__btn"
      title="Export PDF"
      @click="$emit('pdf')"
    >
      <span class="mdi mdi-file-pdf-box"></span>
    </button>
    <button
      type="button"
      class="export-buttons__btn"
      title="Export Excel"
      @click="$emit('excel')"
    >
      <span class="mdi mdi-file-excel-box"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ExportButtons"
};
</script>

<style scoped>
.export-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.export-buttons__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: var(--radius-sm, 6px);
  background: var(--accent-050);
  color: var(--accent-600);
  cursor: pointer;
  transition: background var(--dur, 0.15s) var(--ease, ease),
    color var(--dur, 0.15s) var(--ease, ease);
}

.export-buttons__btn .mdi {
  font-size: 1.2rem;
  line-height: 1;
}

.export-buttons__btn:hover {
  background: var(--accent-600);
  color: #fff;
}
</style>
